/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { RECEIVED_UPDATE_BENEFICIARIES } from 'state/beneficiaries/BeneficiaryActions';
import { titleCase } from 'services/Formats';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionSuccess } from 'state/analytics/AnalyticsActions';
import { beneficiariesEnabled } from 'services/FeatureFlags';

const UpdateBeneficiariesLogic = createLogic({
  type: [RECEIVED_UPDATE_BENEFICIARIES],

  process({ action }, dispatch, done) {
    if(!beneficiariesEnabled()){
      // dispatch user message
    dispatch(addToast(true, 'Changes Saved'));

    // dispatch analytics message
    const type = titleCase(action.type.slice('RECEIVED_'.length), '_', '');
    dispatch(analyticsActionSuccess('ProfPref', type));

    done();
    }
  }
});

export default UpdateBeneficiariesLogic;
